import BFLLink from "@repo/shared-ui/BFLLink";
import { ComponentContent } from "../../types/stocks";
import { getAllStocksData } from "../../services/TradingMallService";
import { SectionHeader } from "./HeaderSection";
import {
  SUB_TITLE_CHAR_LIMIT,
  textEllipsis,
  TITLE_CHAR_LIMIT,
} from "./clpCardConstant";
import { StocksGrid } from "./StockGrid";
import { MostBroughtStocksClient } from "./MostBroughtStocksClient";

interface MostBroughtStocksProps {
  content?: ComponentContent;
}

export const MostBroughtStocks = async ({
  content,
}: MostBroughtStocksProps) => {
  const topscrips = await getAllStocksData({
    exchId: "0",
    entity: "topscrips",
  });

  return (
    <section className="px-4 py-3">
      <SectionHeader
        action="View Markets"
        title={textEllipsis(
          content?.componentTitle || "View markets",
          TITLE_CHAR_LIMIT,
        )}
        description={textEllipsis(
          content?.componentDescription || "",
          SUB_TITLE_CHAR_LIMIT,
        )}
      />
      <MostBroughtStocksClient
      stocks={topscrips?.stockList || []}
        defaultImage={content?.defaultImageLink || ""}
        errorMessage={content?.stockNotFoundText}
        stockNotFoundImgUrl={content?.stockNotFoundImgUrl || ""}
        modalTitle={content?.modalTitle}
        modalBtnCta={content?.modalBtnCta}
        successMsg={content?.successMsg}
        errorMsg={content?.errorMsg} 
        openInNewTab 
        href={content?.redirectLink}
        label={content?.label}
        />
    </section>
  );
};
